import { render, staticRenderFns } from "./ViewContainer.vue?vue&type=template&id=5443e844&scoped=true"
import script from "./ViewContainer.vue?vue&type=script&lang=js"
export * from "./ViewContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443e844",
  null
  
)

export default component.exports